(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var cookieInfo = function cookieInfo() {
  var cookieInfoContainer = document.querySelector('.cookies');
  var cookieInfoClose = document.querySelector('.cookies__button');
  var cookieinfo = getCookie('cookieinfo');

  if (!cookieinfo) {
    setTimeout(function () {
      cookieInfoContainer.style.display = 'flex';
      cookieInfoContainer.style.transform = 'translateY(0)';
    }, 1000);
  }

  cookieInfoClose.addEventListener('click', function () {
    setCookie('cookieinfo', 'true', 100);
    cookieInfoContainer.style.transform = 'translateY(100%)';
    setTimeout(function () {
      cookieInfoContainer.style.display = 'none';
    }, 1000);
  });
};

var setCookie = function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

var getCookie = function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
};

var _default = cookieInfo;
exports["default"] = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileMenu = exports.dynamicMenu = exports.fixedHeader = void 0;

var fixedHeader = function fixedHeader() {
  var header = document.querySelector('.header');
  window.addEventListener('scroll', function () {
    if (window.pageYOffset !== 0) {
      header.classList.add('header--fixed');
    } else {
      header.classList.remove('header--fixed');
    }
  });
};

exports.fixedHeader = fixedHeader;

var dynamicMenu = function dynamicMenu() {
  var sections = document.querySelectorAll('.header__nav a');
  var currentSectionIndex;
  window.addEventListener('scroll', function () {
    var distance = window.pageYOffset + 400;

    for (var i = 0; i < sections.length; i++) {
      var currLink = sections[i];
      var val = currLink.getAttribute('href');

      if (val.includes('#')) {
        var refElement = document.querySelector(val.replace('/', ''));

        if (refElement.offsetTop <= distance && refElement.offsetTop + refElement.offsetHeight > distance) {
          document.querySelector('.header__nav a').classList.remove('header__nav__item--active');
          currLink.classList.add('header__nav__item--active');
          currentSectionIndex = i;
        } else {
          currLink.classList.remove('header__nav__item--active');
        }
      }
    }
  });
};

exports.dynamicMenu = dynamicMenu;

var mobileMenu = function mobileMenu() {
  menu();
  window.addEventListener('resize', function () {
    menu();
  });
};

exports.mobileMenu = mobileMenu;

var menu = function menu() {
  if (window.innerWidth < 768) {
    var burger = document.querySelector('.header__menu-toggle');
    burger.addEventListener('click', function () {
      document.body.classList.toggle('nav-active');
    });
    var menuItems = document.querySelectorAll('.header__nav a');
    menuItems.forEach(function (menuElement) {
      menuElement.addEventListener('click', function () {
        document.body.classList.remove('nav-active');
      });
    });
  }
};

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var gmap = function gmap() {
  var mapContainer = document.getElementById('gmap');
  var titles = mapContainer.dataset.titles.split(',');
  var lats = mapContainer.dataset.lats.split(',');
  var lngs = mapContainer.dataset.lngs.split(',');
  var locations = [];

  for (var item in titles) {
    locations.push({
      title: titles[item],
      lat: lats[item],
      lng: lngs[item]
    });
  }

  var mapPosition = new google.maps.LatLng(51.0956675, 9.7005641);
  var mapOptions = {
    zoom: 7,
    center: mapPosition,
    scrollwheel: false,
    styles: mapStyle
  };
  var map = new google.maps.Map(mapContainer, mapOptions);

  for (var _i = 0, _locations = locations; _i < _locations.length; _i++) {
    var location = _locations[_i];
    new google.maps.Marker({
      position: new google.maps.LatLng(location.lat, location.lng),
      map: map,
      title: location.title
    });
  }
};

var mapStyle = [{
  "featureType": "all",
  "elementType": "geometry.fill",
  "stylers": [{
    "weight": "2.00"
  }]
}, {
  "featureType": "all",
  "elementType": "geometry.stroke",
  "stylers": [{
    "color": "#9c9c9c"
  }]
}, {
  "featureType": "all",
  "elementType": "labels.text",
  "stylers": [{
    "visibility": "on"
  }]
}, {
  "featureType": "landscape",
  "elementType": "all",
  "stylers": [{
    "color": "#f2f2f2"
  }]
}, {
  "featureType": "landscape",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "landscape.man_made",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "poi",
  "elementType": "all",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "road",
  "elementType": "all",
  "stylers": [{
    "saturation": -100
  }, {
    "lightness": 45
  }]
}, {
  "featureType": "road",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#eeeeee"
  }]
}, {
  "featureType": "road",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#7b7b7b"
  }]
}, {
  "featureType": "road",
  "elementType": "labels.text.stroke",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "road.highway",
  "elementType": "all",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "road.arterial",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "transit",
  "elementType": "all",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "water",
  "elementType": "all",
  "stylers": [{
    "color": "#46bcec"
  }, {
    "visibility": "on"
  }]
}, {
  "featureType": "water",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#c8d7d4"
  }]
}, {
  "featureType": "water",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#070707"
  }]
}, {
  "featureType": "water",
  "elementType": "labels.text.stroke",
  "stylers": [{
    "color": "#ffffff"
  }]
}];
var _default = gmap;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientsSlider = exports.heroSlider = void 0;

var heroSlider = function heroSlider() {
  var heroSlider = tns({
    container: '.hero__slider',
    mode: 'gallery',
    slideBy: 'page',
    controlsText: ["", ""],
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayButton: false
  });
};

exports.heroSlider = heroSlider;

var clientsSlider = function clientsSlider() {
  var clientsSlider = tns({
    container: '.clients__slider',
    items: 1,
    slideBy: 1,
    // autoplay: true,
    controlsText: ["", ""],
    nav: false,
    mouseDrag: true,
    responsive: {
      640: {
        items: 2
      },
      900: {
        items: 4
      }
    }
  });
};

exports.clientsSlider = clientsSlider;

},{}],5:[function(require,module,exports){
"use strict";

var _header = require("./components/header");

var _sliders = require("./components/sliders");

var _map = _interopRequireDefault(require("./components/map"));

var _cookieInfo = _interopRequireDefault(require("./components/cookie-info"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

(0, _header.fixedHeader)();
(0, _header.dynamicMenu)();
(0, _header.mobileMenu)();
(0, _map["default"])();
(0, _cookieInfo["default"])();

if (document.body.classList.contains('home')) {
  (0, _sliders.heroSlider)();
  (0, _sliders.clientsSlider)();
}

},{"./components/cookie-info":1,"./components/header":2,"./components/map":3,"./components/sliders":4}]},{},[5]);
